import React from 'react'
const REVIEW_SUBMITTED_TEXT = 'Your review is being processed, it will be published in a few minutes.'

const ReviewSubmitted = ({ onClose }) => {
  return (
    <div className='write-review-container'>
      <div className='jdgm-form-wrapper'>
        <div className='review-success-message'>
          <p>{REVIEW_SUBMITTED_TEXT}</p>
          <div
            onClick={onClose}
            className='close-icon'
          >
            <svg
              className='close-icon'
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <path d='M18.53 17.4698C18.823 17.7628 18.823 18.2378 18.53 18.5308C18.384 18.6768 18.192 18.7508 18 18.7508C17.808 18.7508 17.616 18.6778 17.47 18.5308L12 13.0608L6.52999 18.5308C6.38399 18.6768 6.19199 18.7508 5.99999 18.7508C5.80799 18.7508 5.61599 18.6778 5.46999 18.5308C5.17699 18.2378 5.17699 17.7628 5.46999 17.4698L10.94 11.9998L5.46999 6.52981C5.17699 6.23681 5.17699 5.76177 5.46999 5.46877C5.76299 5.17577 6.238 5.17577 6.531 5.46877L12.001 10.9388L17.471 5.46877C17.764 5.17577 18.239 5.17577 18.532 5.46877C18.825 5.76177 18.825 6.23681 18.532 6.52981L13.062 11.9998L18.53 17.4698Z' />
            </svg>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReviewSubmitted
